import { acceptHMRUpdate, defineStore } from "pinia";
import { computed, ref } from "vue";

import type { IOperatorSettings } from "@/data/model/User";

export const useOperatorSettingsStore = defineStore("operatorSettings", () => {
    const operatorSettings = ref<IOperatorSettings | null>();

    const locationLanguage = computed(() => operatorSettings.value?.location?.language);
    const productionTileViewMode = computed(() => operatorSettings.value?.productionTileViewMode);
    function setOperatorSettings(settings: IOperatorSettings | null) {
        operatorSettings.value = settings;
    }

    return {
        setOperatorSettings,
        locationLanguage,
        productionTileViewMode,
    };
});

if (import.meta.hot) {
    import.meta.hot.accept(acceptHMRUpdate(useOperatorSettingsStore, import.meta.hot));
}
